<!-- <section>
  <div class="nav h-sm h-md">
    <un-nav [menus]="menus"></un-nav>
  </div>
  <main>
    <router-outlet></router-outlet>
  </main>
</section> -->

<nz-layout class="layout">
  <nz-header>
    <un-header></un-header>
    <un-nav class="nav h-sm h-md" [menus]="menus"></un-nav>
  </nz-header>
  <nz-content>
    <main class="inner-content">
      <router-outlet></router-outlet>
    </main>
  </nz-content>
  <nz-footer> </nz-footer>
</nz-layout>
